export default ({ title, body, successText, noBalanceRedirect, customerId, translations }) => ({
  title,
  body,
  defaultTitle: title,
  defaultBody: body,
  successText,
  noBalanceRedirect,
  customerId,

  giftCardData: {
    cardNumber: "",
    cardPin: "",
    customerId,
  },

  showPinField: false,
  showStatus: false,
  errorMessage: "",
  balance: 0,

  translations,

  moneyFormatter: new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }),

  togglePinField() {
    this.showPinField = this.giftCardData.cardNumber.length > 8;
    if (!this.showPinField) {
      this.giftCardData.cardPin = ""; // Reset PIN field if hidden
    }
  },

  validateAndSubmit() {
    // Basic validation
    if (!this.giftCardData.cardNumber.match(/^\w+$/)) {
      // TODO: Use translations
      this.errorMessage = "Invalid card number format.";
      return;
    }

    if (this.showPinField && (this.giftCardData.cardPin.length !== 4 || isNaN(this.giftCardData.cardPin))) {
      // TODO: Use translations
      this.errorMessage = "Invalid PIN.";
      return;
    }

    this.errorMessage = ""; // Clear previous errors
    this.checkBalance();
  },

  checkBalance() {
    fetch("https://gift-card-service.shave.io/activate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.giftCardData),
    })
      .then((response) => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then((data) => {
        if (data.error) {
          this.handleApiError(data);
        } else {
          this.title = "Success!";
          this.body = this.successText;
          this.balance = data.balance;
          this.showStatus = true;
        }
      })
      .catch((error) => {
        this.errorMessage = this.translations.general_error;
        window.console.error(error);
      });
  },

  handleApiError(data) {
    if (data.error === 'error_check_balance' && data.code === '03') {
      this.errorMessage = this.translations['error_check_balance_code'];
    } else if (data.error === 'error_check_balance' && data.code === '20') {
      this.errorMessage = this.translations['error_check_balance_pin'];
    } else if (data.error === 'error_check_balance') {
      this.errorMessage = `<span style="color: rgb(var(--color-button))">${this.translations['general_error']}</span>
      <a target="_blank" href="${this.translations['error_club_pro_link']}">
        <strong>${ this.translations['error_club_pro_text'] }</strong>
      </a>`;
    } else if (data.error === 'error_card_no_balance') {
      this.errorMessage = `<span style="color: rgb(var(--color-button))">${this.translations['error_card_no_balance']}</span>
        <a target="_blank" href="${this.noBalanceRedirect}">
          <strong>${this.translations['error_card_no_balance_link_text']}</strong>
        </a>`;
    } else {
      this.errorMessage = `<span style="color: rgb(var(--color-button))">${this.translations.general_error}</span>
        <a target="_blank" href="${this.translations.error_club_pro_link}">
          <strong>${this.translations.error_club_pro_text}</strong>
        </a>
      `;
    }
  },

  resetForm() {
    this.title = this.defaultTitle;
    this.body = this.defaultBody;
    this.giftCardData.cardNumber = "";
    this.giftCardData.cardPin = "";
    this.showPinField = false;
    this.showStatus = false;
    this.errorMessage = "";
    this.balance = 0;
  },

  get formattedBalance() {
    return this.moneyFormatter.format(this.balance);
  },
});